import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Pill from '../Pill'
import styles from './SelectablePill.module.scss'

const propTypes = {
  /**
   * content of the pill
   */
  children: PropTypes.node.isRequired,
  /**
   * Defines if pill is selected or not
   */
  selected: PropTypes.bool,
  /**
   * Callback when pill is clicked
   */
  onChange: PropTypes.func,
}

const defaultProps = {
  onChange: () => {},
  selected: false,
}

function SelectablePill(props) {
  const { children, selected, onChange } = props

  return (
    <button type="button" className={styles.transparentButton} onClick={() => onChange(!selected)}>
      <Pill className={clsx(selected && 'text-color-primary')} textGray={!selected}>
        {children}
        {selected ? (
          <i className={clsx('fas fa-times ml-2', styles.iconSize)} />
        ) : (
          <i className={clsx('fas fa-plus ml-2 text-color-primary', styles.iconSize)} />
        )}
      </Pill>
    </button>
  )
}

SelectablePill.propTypes = propTypes
SelectablePill.defaultProps = defaultProps

export default SelectablePill
